import { render, staticRenderFns } from "./orgInfo.vue?vue&type=template&id=65c0cddf&scoped=true&"
import script from "./orgInfo.vue?vue&type=script&lang=js&"
export * from "./orgInfo.vue?vue&type=script&lang=js&"
import style0 from "./orgInfo.vue?vue&type=style&index=0&id=65c0cddf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0cddf",
  null
  
)

export default component.exports